module.exports = "/_next/static/media/ea9914aa3c526aa404f64bea6dc9dbaf.svg";